import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
//import Storage from '../../storage';
import AuthService from "../../services/auth-service";

// export const PrivateRoute = (props: RouteProps) =>
//     (Storage.user.get() != null && Storage.token.get() != null)
//         ? <Route {...props} /> 
//         : <Redirect to="/error" />

        const PrivateRoute = ({ component: Component, ...rest }) => (
            <Route
                {...rest}
                render={(props) =>
                    AuthService.isAuthenticated() ? (
                        <Component {...props} />
                    ) : (
                        <Redirect
                            to={{ pathname: "/", state: { from: props.location } }}
                        />
                    )
                }
            />
        );

export default PrivateRoute;